import { useRootNavigationState } from 'expo-router';

/**
 * Returns `true` once the expo-router navigation container is fully mounted
 * and has a state key assigned.
 */
export const useIsNavigationReady = () => {
  const rootNavigationState = useRootNavigationState();

  return Boolean(rootNavigationState?.key);
};
